/* ********************************************
 * import
 * ****************************************** */
import {gsap} from "gsap";
import {mediaQuery} from "../utils/utils";
// import {ScrollTrigger} from "gsap/ScrollTrigger";

export function kvAnimation() {
  const observeFigure = document.querySelector('.home_kv_main');
  const observeImg = document.querySelector('.home_kv_main_img');
  const triggerKv = document.querySelector('.home_kv');
  // const triggerUnder = document.querySelector('.home_kv_under');
  const triggerCopy = document.querySelector('.home_kv_copy');
  const triggerConcept = document.querySelector('.home_concept');
  const triggerInterior = document.querySelector('.home_interior');

  if (mediaQuery() === 'pc') {

    const observeFigureHeight = observeFigure.offsetHeight; // observeFigureの高さを取得
    const viewportHeight = window.innerHeight; // 画面の高さを取得
    const dynamicOffset = viewportHeight - observeFigureHeight; // 差
    // const yOffset = dynamicOffset / 2; // 画面の高さと observeFigure の高さの差から中央に配置するためのオフセットを計算
    let yOffset = dynamicOffset;
    if (dynamicOffset < 0) {
      yOffset = 0;
    }

    gsap.to(observeFigure, {
      scrollTrigger: {
        trigger: triggerKv,
        start: 'top top', // content viewport
        endTrigger: triggerInterior,
        end: 'bottom bottom',
        // endTrigger: triggerUnder,
        // end: () => `bottom bottom-=${dynamicOffset}px`, // observeFigureの高さ分オフセット
        pin: observeFigure,
        pinSpacing: true,
        scrub: 1,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.to(observeFigure, {
      clipPath: "inset(0vw 0vw 0vw 0vw)",
      x: "-6.9444444444vw",
      scrollTrigger: {
        trigger: triggerCopy,
        start: 'top top', // content viewport
        endTrigger: triggerConcept,
        end: 'top center',
        scrub: 1.8,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.to(observeImg, {
      scale: "0.9897070622",
      y: yOffset, // 中央に配置するためにY軸方向にオフセット
      scrollTrigger: {
        trigger: triggerCopy,
        start: 'top top', // content viewport
        endTrigger: triggerConcept,
        end: 'top center',
        scrub: 1.8,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.to(observeFigure, {
      opacity: 0,
      scrollTrigger: {
        // trigger: triggerUnder,
        // start: () => `bottom bottom-=${dynamicOffset}px`, // observeFigureの高さ分オフセット
        trigger: triggerConcept,
        start: () => `top center+=${dynamicOffset}px`, // observeFigureの高さ分オフセット
        endTrigger: triggerConcept,
        end: 'top top',
        scrub: 1.8,
        invalidateOnRefresh: true, // update on resize
      },
    });

  } else {

    gsap.to(observeFigure, {
      scrollTrigger: {
        trigger: triggerKv,
        start: 'top top', // content viewport
        endTrigger: triggerConcept,
        end: 'top center+=10%',
        pin: observeFigure,
        pinSpacing: true,
        scrub: 1,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.to(observeFigure, {
      clipPath: "inset(0vw 0vw 0vw 0vw)",
      x: "-6vw",
      // y: "3.9444444444vw",
      scrollTrigger: {
        trigger: triggerCopy,
        start: 'bottom top', // content viewport
        endTrigger: triggerConcept,
        end: 'top center',
        scrub: 1.8,
        invalidateOnRefresh: true, // update on resize
      },
    });

    gsap.to(observeImg, {
      scale: "0.521390374331551",
      scrollTrigger: {
        trigger: triggerCopy,
        start: 'bottom top', // content viewport
        endTrigger: triggerConcept,
        end: 'top center',
        scrub: 1.8,
        invalidateOnRefresh: true, // update on resize
      },
    });

  }
}